import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import TextComponent from 'shared/components/TextComponent';
import TextAreaComponent from 'shared/components/TextAreaComponent';

const EmailQuoteModal = (props) => {
  const {
    quote,
    show,
    onSend,
    onHide,
    title,
    defaultEmail,
    notePlaceHolder,
    sendLabel,
    cancelLabel,
  } = props;

  const [email, setEmail] = useState(defaultEmail);
  const [note, setNote] = useState('');

  const onConfirm = () => {
    const data = {
      product_quote_number: quote.number,
      product_quote_email_request: {
        product_quote_id: quote.id,
        email,
        note,
      },
    };
    onSend(data);
    setNote('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <TextComponent
                label="To"
                placeholder="Enter email address"
                name="email"
                groupName={null}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <TextAreaComponent
                label="Add a note"
                placeholder={notePlaceHolder}
                value={note}
                name="note"
                groupName={null}
                type="text"
                onChange={(e) => setNote(e.target.value)} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {cancelLabel}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {sendLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EmailQuoteModal.defaultProps = {
  show: false,
  title: 'Email Quote',
  notePlaceHolder: 'I thought you might be interested in this page from Pentalogix.',
  sendLabel: 'Send',
  cancelLabel: 'Cancel',
};

export default EmailQuoteModal;
